






































import { UiIconButton } from './keen-ui';
import TransitionHeight from './transition-height.component.vue';

export default {
  name: 'facets-list',
  props: {
    facets: {
      type: Array,
      required: true
    }
  },
  components: {
    UiIconButton,
    TransitionHeight
  },
  data: function () {
    return {
      expandedFacetId: undefined
    };
  },
  methods: {
    isFacetExpanded: function (facetId: string): boolean {
      return (facetId === this.expandedFacetId);
    },
    toggleFacetExpanded: function (facetId: string): void {
      this.expandedFacetId = (!this.isFacetExpanded(facetId) ? facetId : undefined);
    }
  }
};

